import { useState } from 'react';
import { useCheckPaymentExpiration } from '~/domain/Payments';
import history from '~/browserHistory';
import { routes } from '~/routes';
import { Ribbon } from '@tempmee/react';
import { OutlineWarning01Icon, SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';

interface IPaymentWarningBannerProps {
  officeId?: string;
  containerStyle?: React.CSSProperties;
}

export const PaymentWarningBanner = ({ officeId, containerStyle }: IPaymentWarningBannerProps) => {
  const [showAddPaymentPopup, setShowAddPaymentPopup] = useState(false);
  const { isInvalidPayment } = useCheckPaymentExpiration(officeId);

  if (!isInvalidPayment) {
    return null;
  }

  return (
    <>
      <Ribbon
        variant="hard-warning"
        Icon={SolidExclamationWarningAlertIcon}
        onClick={() => setShowAddPaymentPopup(true)}
        style={containerStyle}
      >
        Your payment method is either missing or expired. Please update it to unlock candidate names and send invites to professionals.
      </Ribbon>

      {showAddPaymentPopup && (
        <ConfirmPopup
          title="Payment Method Missing or Expired"
          description="In order to invite a professional, please add or update your preferred payment method."
          leftButtonText="Go Back"
          leftButtonAction={() => setShowAddPaymentPopup(false)}
          rightButtonText="Add Payment"
          rightButtonAction={() => {
            setShowAddPaymentPopup(false);
            history.push(routes.paymentInformation);
          }}
          closePopup={() => setShowAddPaymentPopup(false)}
          Icon={() => <OutlineWarning01Icon color={colors.warning[500]} />}
        />
      )}
    </>
  );
};
